import { apiClient } from './client';
import { createCrudApi } from './crud';
import type { ApiSuccess } from '../types';

export interface Vendor {
  id: number;
  vendorCode: string;
  vendorName: string;
  gstNumber: string | null;
  panNumber: string | null;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  bankIfsc: string | null;
  email: string | null;
  mobile: string | null;
  regionId: number | null;
  serviceCategory: string | null;
  status: 'active' | 'inactive' | 'blacklisted';
  createdAt: string;
}

export interface CreateVendorInput {
  vendorName: string;
  gstNumber?: string;
  panNumber?: string;
  bankAccountName?: string;
  bankAccountNumber?: string;
  bankIfsc?: string;
  email?: string;
  mobile?: string;
  regionId?: number | null;
  serviceCategory?: string;
  status?: 'active' | 'inactive' | 'blacklisted';
}

export interface VendorDocument {
  id: number;
  docType: string;
  fileName: string;
  fileUrl: string;
  version: number;
  isCurrent: boolean;
  createdAt: string;
}

const base = createCrudApi<Vendor, CreateVendorInput>('vendors');

export const vendorsApi = {
  ...base,
  async listDocuments(id: number): Promise<VendorDocument[]> {
    const { data } = await apiClient.get<ApiSuccess<VendorDocument[]>>(`/vendors/${id}/documents`);
    return data.data;
  },
  async addDocument(id: number, input: { docType: string; fileName: string; fileUrl: string }): Promise<VendorDocument> {
    const { data } = await apiClient.post<ApiSuccess<VendorDocument>>(`/vendors/${id}/documents`, input);
    return data.data;
  },
};
